const HANDLERS_PROPERTY = '__v-click-outside'
const HAS_WINDOWS = typeof window !== 'undefined'
const HAS_NAVIGATOR = typeof navigator !== 'undefined'
const IS_TOUCH =
    HAS_WINDOWS &&
    ('ontouchstart' in window ||
        (HAS_NAVIGATOR && navigator.msMaxTouchPoints > 0))
const EVENTS = IS_TOUCH ? ['touchstart'] : ['click']

function processDirectiveArguments(bindingValue) {
    const isFunction = typeof bindingValue === 'function'
    if (!isFunction && typeof bindingValue !== 'object') {
        throw new Error(
            'v-click-outside: Binding value must be a function or an object',
        )
    }

    return {
        handler: isFunction ? bindingValue : bindingValue.handler,
        // The events to listen to
        events: bindingValue.events || EVENTS,
        // Whether to allow a click outside to trigger the handler
        isActive: !(bindingValue.active === false),
        // The default value is false. Sets the capture option for EventTarget addEventListener method.resolveTeamIdForParticipation
        // Could be useful if some event's handler calls stopPropagation method preventing event bubbling.
        capture: !!bindingValue.capture,
        // The selectors of the elements to ignore when clicked on these elements
        ignoredElements: bindingValue.ignore || []
    }
}

function onEvent({ el, event, handler, ignoredElements }) {
    const path = event.composedPath && event.composedPath();
    const isClickOutside = path ? path.indexOf(el) < 0 : !el.contains(event.target)

    if (!isClickOutside) {
        return
    }

    // Check if the click was targeted on an ignored element or its children
    let clickedOnIgnored = false;
    if (path && path.length && ignoredElements && ignoredElements.length) {
        for (let i = 0; i < path.length; i++) {
            for (let j = 0; j < ignoredElements.length; j++) {
                if (ignoredElements[j] && path[i].matches && path[i].matches(ignoredElements[j])) {
                    clickedOnIgnored = true;
                    break;
                }
            }
        }
    }

    if (clickedOnIgnored) {
        return
    }

    handler(event);
}

function bind(el, { value }) {
    const {
        events,
        handler,
        isActive,
        capture,
        ignoredElements
    } = processDirectiveArguments(value)
    if (!isActive) {
        return
    }

    el[HANDLERS_PROPERTY] = events.map((eventName) => ({
        event: eventName,
        srcTarget: document.documentElement,
        handler: (event) => onEvent({ el, event, handler, ignoredElements }),
        capture,
    }))


    el[HANDLERS_PROPERTY].forEach(({ event, srcTarget, handler }) =>
        setTimeout(() => {
            // Note: More info about this implementation can be found here:
            //       https://github.com/ndelvalle/v-click-outside/issues/137
            if (!el[HANDLERS_PROPERTY]) {
                return
            }
            srcTarget.addEventListener(event, handler, capture)
        }, 0),
    )
}

function unbind(el) {
    const handlers = el[HANDLERS_PROPERTY] || []
    handlers.forEach(({ event, srcTarget, handler, capture }) =>
        srcTarget.removeEventListener(event, handler, capture),
    )
    delete el[HANDLERS_PROPERTY]
}

function update(el, { value, oldValue }) {
    if (JSON.stringify(value) === JSON.stringify(oldValue)) {
        return
    }
    unbind(el)
    bind(el, { value })
}

export const ClickOutside = {
    bind,
    update,
    unbind,
};

export default ClickOutside